/**
 * 공유 페이지(비회원)의 카드 — **대표 이미지만** 남긴다. 소재 공유·브랜드 공유·크리에이터 공유의 격자가 같은 것을 쓴다.
 *
 * 🔑 영상 주소(수집 주소 `videoSrc` · 새 주소 묻기 `videoAsk`)를 지운다 — 격자가 영상을 받거나 주소를 묻지 않고,
 *   도는 표시도 서지 않는다. 영상 글이라는 표시(`video`)는 남겨 칸 왼쪽 아래 작은 ▶ 배지만 선다.
 * ⚠️ 로그인한 화면의 카드에는 쓰지 마라 — 영상이 통째로 죽는다.
 */

import type { VideoUrlResult } from 'src/types/search-all/video-url';
import type { MediaCard } from 'src/sections/search-all/utils/search-all-media-cards';

/** @returns 영상 주소를 뺀 같은 카드 */
export function toPublicStillCard(card: MediaCard): MediaCard {
  return { ...card, videoSrc: '', videoAsk: null };
}

/** 공유 격자에 넘기는 빈 영상 결과 — 묻지 않으니 받을 것도 없다 */
export const PUBLIC_NO_VIDEOS: Map<string, VideoUrlResult> = new Map();
